import React, { useCallback, useState } from "react";

// ANT DESIGN IMPORTS
import { EditOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";

//PROJECT IMPORTS
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import styles from "../../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import { apiConfig, labelConfig } from "../../../../customer.config";

const EditKYCBioInfo = (props) => {
  const {
    currentCustomerObj,
    userData,
    refreshList,
    customerDetails,
    identifactionTypeData,
    useForm,
  } = props;
  const { session } = userData;

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return (
        minDate != null &&
        current.isBefore(minDate) &&
        !current.isSame(minDate, "day")
      );
    },
    [minDate]
  );

  const onSubmit = (formValues) => {
    formValues.externalId = currentCustomerObj.id;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.isCustomerDirector = formValues.directorCustomer;
    formValues.hasEstablishedRelationship = formValues.establishedRelationship;
    formValues.expiryDate = formValues.expiryDate
      ? BOM.DateTime(formValues.expiryDate, "only-date")
      : BOM.DateTime(customerDetails?.expiryDate, "only-date");

    delete formValues.directorCustomer;
    delete formValues.establishedRelationship;

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateKycMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      }
    );
  };
  return (
    <>
      {BOM.HasPermission("CREATE_CLIENT_LIMIT") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          style={{
            marginLeft: "auto",
          }}
          onClick={showModal}
        >
          <EditOutlined />
          &nbsp;{labelConfig.edit}
        </Button>
      )}
      <Modal
        title="Edit KYC info"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Row>
            <Divider orientation="left">Bio Information</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.fullName}
                name="fullname"
                // rules={[
                //   {
                //     required: true,
                //     message: BOM.CheckReqFld(labelConfig.fullName),
                //   },
                // ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.fullName)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.previousName} name="previousName">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.previousName
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.identifactionType} name="idTypeId">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.identifactionType,
                    "select"
                  )}
                  options={identifactionTypeData}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.issuingAuthority}
                name="issuingAuthority"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.issuingAuthority
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.identifactionNo} name="idNo">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.identifactionNo
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.expiryDate} name="expiryDate">
                <DatePicker
                  disabledDate={disableDaysBeforeToday}
                  // size="small"
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default EditKYCBioInfo;
